import axios from 'axios'
import config from '@/config'
import applyUrlTemplate from './applyUrlTemplate'
import applyDefaultParams from './applyDefaultParams'
import { applyCacheResuest, applyCacheResponse } from './cache'
import store from '@/store'

import normalizeAxiosError, {
// SERVER_ERROR,
// TIMEOUT_ERROR,
// NETWORK_ERROR
} from './normalizeAxiosError'
import router from '@/router'

const API_TIMEOUT = 300000 // 300s
// const API_TIMEOUT = 5000 // 30s

const tdealApi = axios.create({
  baseURL: config.tdealApiBaseUrl,
  timeout: API_TIMEOUT
})

tdealApi.interceptors.request.use(applyCacheResuest)
tdealApi.interceptors.request.use(applyUrlTemplate)
tdealApi.interceptors.request.use(applyDefaultParams)

tdealApi.interceptors.response.use(applyCacheResponse)
tdealApi.interceptors.response.use(null, normalizeAxiosError)
tdealApi.interceptors.response.use(null, function (err) {
  // if (err.code === TIMEOUT_ERROR || err.code === NETWORK_ERROR) {
  //   // soter.commit('error...', err)
  // }
  // if (err.code === SERVER_ERROR) {
  //   // soter.commit('error...', err)
  //   if (router.app._route.query.isDebug !== 'true') {
  //     router.push({path: '/etc/dataerror'})
  //   }
  // }
  router.push({path: '/etc/dataerror'})
  return Promise.reject(err)
})

tdealApi.interceptors.response.use(function (response) {
  if (response.data.error) {
    if (response.data.error.code === '240') {
      alert('중복된 이름이 존재합니다.')
    } else if (response.data.error.code === '242') {
      alert('삭제가 불가능 합니다.')
    } else if (response.data.error.code === '243') {
      alert('쿠폰 발급이 완료되어 중지 불가능합니다.')
    } else if (response.data.error.code === '250') {
      alert('접근 권한이 없습니다.')
      router.push({path: store.getters['authentication/getUserInitPage']})
    } else if (response.data.error.code === '251') {
      alert('접근 권한이 없습니다.')
    } else {
      if (response.data.error.code >= '260' && response.data.error.code <= '277') {
        return response
      } else {
        return response
      }
    }
  } else {
    if (store.getters['authentication/getRefreshTime'] === '') {
      if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
    } else {
      let afterRefreshTime = new Date().getTime()
      let beforeRefreshTime = store.getters['authentication/getRefreshTime'].getTime()
      // router refresh 후 3초 지났을때 refresh 하도록 간격 제어
      if (afterRefreshTime - beforeRefreshTime >= 3000) {
        if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
      }
    }
    return response
  }
}, async function (error) {
  router.push({path: '/etc/dataerror'})
  return Promise.reject(error)
})

export default tdealApi
